module.exports = __webpack_public_path__ + "img/icon_banner.059e29a6.png";